// extracted by mini-css-extract-plugin
export default {"cameraWrapper":"Camera_cameraWrapper__vPZkx","centeredImage":"Camera_centeredImage__TVsaN"};